import { useState } from 'react';
import useRestApiClient from 'src/hooks/useRestApiClient';

const useUser = () => {
  const [user, setUser] = useState(null);
  const client = useRestApiClient();

  const addUser = async (payload) => {
    const response = await client.post('/users', payload);
    const {
      data: { message: value }
    } = response;
    setUser(value);
    return value;
  };

  const updateUser = async (userId, payload) => {
    const response = await client.patch(`/users/${userId}`, payload);
    const {
      data: { message: value }
    } = response;
    setUser(value[0]);
    return value[0];
  };

  const fetchUser = async (userId) => {
    const response = await client.get(`/users/${userId}`);
    const {
      data: { message: value }
    } = response;
    setUser(value[0]);
    return value[0];
  };

  const fetchUserByEmail = async (email) => {
    const response = await client.get(`/users?email=${email}&encrypted=true&eap=true`);
    const {
      data: { message: value }
    } = response;
    setUser(value[0]);
    return value[0];
  };

  return { user, addUser, updateUser, fetchUser, fetchUserByEmail };
};

export default useUser;
